// src/utils/date-utils.ts
// utils.ts

/**
 * Ritorna una lista di anni dal 1924 fino all'anno corrente come stringhe.
 */
export const getYearsList = (): string[] => {
  const currentYear = new Date().getFullYear()
  const years: string[] = []
  for (let year = currentYear; year >= 1924; year--) {
    years.push(year.toString())
  }
  return years
}

/**
 * Ritorna una lista dei nomi dei mesi.
 */
export const getMonthsList = (): string[] => {
  return Array.from({ length: 12 }, (_, i) => (i + 1).toString())
}

/**
 * Controlla se un anno è bisestile.
 */
const isLeapYear = (year: number): boolean => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

/**
 * Ritorna una lista di giorni da "1" a "31".
 */
export const getDefaultDaysList = (): string[] => {
  return Array.from({ length: 31 }, (_, i) => (i + 1).toString())
}

/**
 * Ritorna una lista di giorni di un dato mese e anno.
 * @param month - Il mese (da 1 a 12).
 * @param year - L'anno.
 */
export const getDaysInMonth = (month: number, year?: number): number[] => {
  const februaryNumDays = year === undefined ? 28 : isLeapYear(year) ? 29 : 28
  // Array con i giorni di ciascun mese (index 0 = Gennaio)
  const daysInMonth = [31, februaryNumDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

  // Ritorna un array con i giorni da 1 a N, dove N è il numero di giorni nel mese
  return Array.from({ length: daysInMonth[month - 1] }, (_, i) => i + 1)
}

/**
 * Ritorna una lista di giorni di un dato mese e anno nel formato dd/mm/yyyy.
 */
export const getDateFormatted = (day?: string, month?: string, year?: string) => {
  const currentDate = new Date()
  const _day = day ? day : currentDate.getUTCDate().toString()
  const _month = month ? month : (currentDate.getMonth() + 1).toString()
  const _year = year ? year : currentDate.getFullYear().toString()

  const dayFormatted = _day?.length === 1 ? '0' + _day : _day
  const monthFormatted = _month?.length === 1 ? '0' + _month : _month

  return `${dayFormatted}/${monthFormatted}/${_year}`
}

// Lista delle regioni d'Italia
const italianRegions: string[] = [
  'Abruzzo',
  'Basilicata',
  'Calabria',
  'Campania',
  'Emilia-Romagna',
  'Friuli Venezia Giulia',
  'Lazio',
  'Liguria',
  'Lombardia',
  'Marche',
  'Molise',
  'Piemonte',
  'Puglia',
  'Sardegna',
  'Sicilia',
  'Toscana',
  'Trentino-Alto Adige',
  'Umbria',
  "Valle d'Aosta",
  'Veneto'
]

export const getItalianRegions = (): string[] => {
  return italianRegions
}
